import React from "react";
import { useParams } from "react-router-dom";
import RouteAccessOneContent from "../RouteAccessOneContent";
import RouteSomeAccessToContentType from "../RouteSomeAccessToContentType";


//used in SM route renderer, but can be useful in general
export const ConditionalAccessWrapper = ({children, param, paramMap}) => {
  const params = useParams();
  const AccessControlCompsLookup = {
    RouteAccessOneContent,
    RouteSomeAccessToContentType
  }
  
  const compPropConfig = paramMap?.[params?.[param]];
  const AccessRouteComp = AccessControlCompsLookup[compPropConfig?.comp];
  const accessRouteProps = compPropConfig?.props || {};
  
  if(!AccessRouteComp) return children;
  
  return (
    <AccessRouteComp {...accessRouteProps}>
      {children}
    </AccessRouteComp>
  );
};

